import { Button, TextArea } from "@fluidattacks/design";
import type { TFormMethods } from "@fluidattacks/design";
import { Fragment, useCallback, useEffect } from "react";
import { useHotkeys } from "react-hotkeys-hook";
import { useTranslation } from "react-i18next";

import type { ICommentForm } from "../types";
import { MAX_LENGTH } from "../validations";

const ContentForm = ({
  formState: { isSubmitSuccessful, errors, touchedFields },
  handleSubmit,
  onSubmit,
  register,
  reset,
  setValue,
  watch,
}: TFormMethods<ICommentForm> & {
  onSubmit: (values: ICommentForm) => void;
}): JSX.Element => {
  const { t } = useTranslation();
  const comment = watch("comment-editor");

  const formatCommentInplace = useCallback((): void => {
    setValue("comment-editor", comment.trim());
  }, [setValue, comment]);

  const handleHotkey = useCallback((): void => {
    formatCommentInplace();
    handleSubmit(onSubmit);
  }, [formatCommentInplace, handleSubmit, onSubmit]);

  useHotkeys("ctrl+enter", handleHotkey, { enableOnFormTags: ["TEXTAREA"] });

  useEffect((): void => {
    if (isSubmitSuccessful) {
      reset();
    }
  }, [isSubmitSuccessful, reset]);

  return (
    <Fragment>
      <TextArea
        error={errors["comment-editor"]?.message}
        isTouched={touchedFields["comment-editor"]}
        maxLength={MAX_LENGTH}
        name={"comment-editor"}
        onBlur={formatCommentInplace}
        placeholder={t("comments.editorPlaceholder")}
        register={register}
        rows={3}
        watch={watch}
      />
      {comment.length > 0 ? (
        <div className={"pv2"}>
          <Button type={"submit"}>{t("comments.send")}</Button>
        </div>
      ) : null}
    </Fragment>
  );
};

export { ContentForm };
